import {AbstractTaskHandler} from "./AbstractTaskHandler";
import TakipXmlParser from "../../../takip_ac/TakipXmlParser";
import {TaskDurum} from "../../../enum/TaskDurum";
import {ITask} from "../GorevYoneticisiTypes";
import MtsTakipAc from "@/plugins/uyap-plugin/takip_ac/MtsTakipAc";
import {MtsXmlParser} from "@/plugins/uyap-plugin/takip_ac/MtsXmlParser";

export class MtsTakipAcTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let parsedFile: MtsXmlParser = MtsXmlParser.fromJson(task.data);
            let takip = new MtsTakipAc();
            takip.parsedFile = parsedFile;
            await takip.hemenTakipAc();
            task.response = takip;
            task.status = TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            throw new Error(e.message)
        }
    }

}